<div class="paginator">
  <button
    class="paginator__control paginator__control--previous"
    (click)="previousPage()"
    [disabled]="isPreviousButtonDisabled"
  >
    <i class="paginator__control-icon material-icon material-icon--outlined">
      keyboard_arrow_left
    </i>
  </button>

  <div class="paginator__pages" #dynamicLinksContainer>
    <ng-container *ngIf="layoutInfo">
      <ng-container *ngIf="layoutInfo.displayLeftSeparator">
        <app-page-link
          [pageIndex]="0"
          [isCurrent]="this.currentPageIndex === 0"
          (click)="goToPage(0)"
        >
          1
        </app-page-link>

        <div class="paginator__separator">...</div>
      </ng-container>

      <app-page-link
        *ngFor="let pageIndex of layoutInfo.visiblePageLinks; trackBy: trackBy"
        [pageIndex]="pageIndex"
        [isCurrent]="this.currentPageIndex === pageIndex"
        (click)="goToPage(pageIndex)"
      >
        {{ pageIndex + 1 }}
      </app-page-link>

      <ng-container *ngIf="layoutInfo.displayRightSeparator">
        <div class="paginator__separator">...</div>

        <app-page-link
          [pageIndex]="maxIndex"
          [isCurrent]="this.currentPageIndex === maxIndex"
          (click)="goToPage(maxIndex)"
        >
          {{ maxIndex + 1 }}
        </app-page-link>
      </ng-container>
    </ng-container>
  </div>

  <button
    class="paginator__control paginator__control--next"
    (click)="nextPage()"
    [disabled]="isNextButtonDisabled"
  >
    <i class="paginator__control-icon material-icon material-icon--outlined">
      keyboard_arrow_right
    </i>
  </button>
</div>
